import CoursesContainer from './Courses/CoursesContainer.js';
import CourseContainer from './Course/CourseContainer.js';
import ModuleContainer from './Module/ModuleContainer.js';
import AssessmentContainer from
  './Assessment/AssessmentContainer.js';
import LoginContainer from './Login/LoginContainer.js';
import Home from './Home/Home.js';
import RegisterContainer from './Register/Register';
import LanguageContainer from './Language/Language';
import ProfileContainer from './Profile/Profile';
import Loading from './Loading/Loading';
import DashboardContainer from './Dashboard/DashboardContainer';
import ResourcesContainer from './Resources/ResourcesContainer';
import ResourcesModuleContainer from './ResourcesModule/ResourcesModuleContainer';
import TagsContainer from './Tags/TagsContainer';

export {
  CoursesContainer,
  CourseContainer,
  ModuleContainer,
  AssessmentContainer,
  LoginContainer,
  DashboardContainer,
  ResourcesContainer,
  ResourcesModuleContainer,
  Home,
  RegisterContainer,
  LanguageContainer,
  ProfileContainer,
  TagsContainer,
  Loading,
};



// WEBPACK FOOTER //
// ./src/components/index.js